import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { useMediaQuery } from '@mui/material';
import ExplicitConfirmationDialog from 'common/dialog-explicit-confirmation/DialogExplicitConfirmation';
import { useLocationRemoveDriverMutation } from './driverStatusEndpoints';

const RemoveDriverDialog = ({ driver, location, onClose }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'), { noSsr: true });

  const [removeDriver, { isSuccess }] = useLocationRemoveDriverMutation();

  const handleRemove = () => {
    const { driverId } = driver;
    const { locationId } = location;
    removeDriver({ driverId, locationId });
  };

  useEffect(() => {
    if (isSuccess) onClose(false);
  }, [isSuccess, onClose]);

  if (isMobile)
    return (
      <Dialog
        open
        slotProps={{
          paper: { elevation: 4 },
        }}
      >
        <DialogTitle>Remove Driver?</DialogTitle>
        <DialogContent sx={{ px: 3 }}>
          <Typography>
            This will remove {driver.lastName}, {driver.firstName} from this location.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ pb: 3, px: 3 }}>
          <Button onClick={onClose} variant="outlined">
            Back
          </Button>
          <Button onClick={handleRemove}>Confirm</Button>
        </DialogActions>
      </Dialog>
    );

  return (
    <ExplicitConfirmationDialog
      confirmationMessage="If you still want to remove the driver, enter the word below and click Confirm."
      confirmationValue="REMOVE"
      dialogOpen
      handleCloseDialog={onClose}
      onConfirm={handleRemove}
      title="Remove Driver?"
      warningList={['This will remove the driver from this location.']}
    />
  );
};

RemoveDriverDialog.propTypes = {
  driver: PropTypes.shape({
    driverId: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({
    locationId: PropTypes.number,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default RemoveDriverDialog;
